var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99937 1C8.25311 1 8.48486 1.14405 8.59717 1.37158L10.5022 5.23098L14.7625 5.85368C15.0135 5.89037 15.2219 6.06637 15.3002 6.30771C15.3785 6.54905 15.3129 6.81389 15.1312 6.99091L12.049 9.99291L12.7764 14.234C12.8193 14.4841 12.7165 14.7369 12.5112 14.886C12.3059 15.0352 12.0337 15.0548 11.8091 14.9367L7.99937 12.9332L4.18967 14.9367C3.96506 15.0548 3.69286 15.0352 3.48755 14.886C3.28223 14.7369 3.1794 14.4841 3.2223 14.234L3.94969 9.99291L0.867547 6.99091C0.685801 6.81389 0.620286 6.54905 0.698538 6.30771C0.776789 6.06637 0.985243 5.89037 1.23628 5.85368L5.49653 5.23098L7.40156 1.37158C7.51388 1.14405 7.74562 1 7.99937 1ZM7.99937 3.17284L6.53717 6.13508C6.44015 6.33165 6.25269 6.46795 6.03579 6.49966L2.76498 6.97774L5.13119 9.28243C5.28844 9.43559 5.36021 9.65634 5.32311 9.8727L4.76482 13.1278L7.68907 11.59C7.88332 11.4878 8.11541 11.4878 8.30967 11.59L11.2339 13.1278L10.6756 9.8727C10.6385 9.65634 10.7103 9.43559 10.8675 9.28243L13.2338 6.97774L9.96295 6.49966C9.74605 6.46795 9.55859 6.33165 9.46156 6.13508L7.99937 3.17284Z",
    fill: "#1E2132"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b1f3a6fe.svg";
export { ForwardRef as ReactComponent };